import React from "react"
import SectionHeader from "../../molecules/SectionHeader/index"
import CTA from "../../atoms/CTA/index"
import { Link } from "gatsby"
import "./styles.scss"
const CaseStudy = ({ caseStudy }) => {
  return (
    <Link to={caseStudy.button.link}>
      <div className="caseStudyMobile">
        <img
          src={caseStudy?.image?.childImageSharp?.fluid?.src}
          alt=""
          className="caseStudyMobile__image"
        />
        <div className="caseStudyMobile__content">
          <SectionHeader type="h3" subtitle={caseStudy.title.subtitle}>
            {caseStudy.title.title}
          </SectionHeader>
          <span className="btn btn--bordered">{caseStudy.button.title}</span>
        </div>
      </div>
    </Link>
  )
}

export default CaseStudy
